import { yup } from '../initYup.ts';

export interface IGreaterThanOptions {
  /** Se true, il check è valido solo in caso di > */
  notEqual?: boolean;
}

declare module 'yup' {
  interface NumberSchema {
    /**
     * Valida un valore massimo in modo che sia sempre maggiore di un minimo
     */
    greaterThan(
      minFieldName: string,
      message?: string,
      options?: IGreaterThanOptions,
    ): NumberSchema;
  }
}

/**
 * Valida un valore massimo in modo che sia sempre maggiore di un minimo
 */
yup.addMethod(
  yup.number,
  'greaterThan',
  function (
    minFieldName: string,
    message?: string,
    options?: IGreaterThanOptions,
  ) {
    return (
      this.test({
        name: 'greaterThan',
        message:
          (message ?? options?.notEqual)
            ? 'Il valore massimo deve essere maggiore del valore minimo'
            : 'Il valore massimo deve essere maggiore o uguale del valore minimo',
        test(value) {
          const minValue = this.parent[minFieldName];
          if (!value) return true;
          if (minValue == null) return true;
          return options?.notEqual ? value > minValue : value >= minValue;
        },
      })
        // Aggiungo un when "vuoto" per forzare la dipendenza del campo con il minField
        .when([minFieldName], (_, schema) => schema)
    );
  },
);
